import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    if (isAdmin) {
      axios
        .get("https://vape-backend-1.onrender.com/api/pending/count")
        .then((r) => setPendingCount(r.data.count))
        .catch(() => {});
    }
  }, [isAdmin]);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const navItems = [
    { to: "/", icon: "📊", label: "Dashboard" },
    { to: "/products", icon: "📦", label: "Products" },
    { to: "/sales", icon: "💰", label: "Sales" },
    { to: "/investors", icon: "💼", label: "Investors" },
    { to: "/damaged", icon: "⚠️", label: "Damaged" },
    ...(isAdmin
      ? [
          {
            to: "/pending",
            icon: "🔔",
            label: "Approvals",
            badge: pendingCount,
          },
        ]
      : []),
  ];

  return (
    <div className="layout">
      {/* Mobile top bar */}
      <div className="mobile-topbar">
        <button className="hamburger-btn" onClick={() => setSidebarOpen(true)}>
          ☰
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div
            className="logo-icon"
            style={{ width: 28, height: 28, fontSize: 14 }}
          >
            💨
          </div>
          <span
            style={{
              fontFamily: "Rajdhani",
              fontWeight: 700,
              color: "var(--accent)",
              fontSize: "1.1rem",
            }}
          >
            VapeTrack
          </span>
        </div>
        <div style={{ width: 36 }}></div>
      </div>

      {/* Sidebar overlay on mobile */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside className={`sidebar ${sidebarOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-logo">
          <div className="logo-icon">💨</div>
          <div>
            <h2>VapeTrack</h2>
            <span>Inventory System</span>
          </div>
          <button
            className="sidebar-close-btn"
            onClick={() => setSidebarOpen(false)}
          >
            ✕
          </button>
        </div>
        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <span>{item.icon}</span>
              <span>{item.label}</span>
              {item.badge > 0 && <span className="badge">{item.badge}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div>
              <div className="user-name">{user?.name}</div>
              <div className="user-role">{user?.role}</div>
            </div>
          </div>
          <button className="logout-btn" onClick={handleLogout}>
            🚪 Logout
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
